import { render, staticRenderFns } from "./TopFooterForm.vue?vue&type=template&id=33859b55&scoped=true&"
import script from "./TopFooterForm.vue?vue&type=script&lang=js&"
export * from "./TopFooterForm.vue?vue&type=script&lang=js&"
import style0 from "./TopFooterForm.vue?vue&type=style&index=0&id=33859b55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33859b55",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EmailBrochureForm: require('/opt/build/repo/apps/shop/components/EmailBrochureForm.vue').default})
